module.exports = __webpack_public_path__ + "img/thaiQrCode.da06a283.png";